import classNames from 'classnames/bind';
import { setGlobalCSSVariables } from 'helpers/styleHelpers';
import { useWindowSize } from 'hooks/useWindowSize';
import styles from 'pages/[communityId]/index.module.scss';

import React, { ReactNode, useEffect } from 'react';

import { useCommunityContext } from 'components/CommunityContext';
import { EventPreviewProvider } from 'components/Contexts/EventPreview/EventPreviewContext';
import { getLayout as getSiteLayout } from 'components/Layouts/SiteLayout';
import Layout from 'components/new/layout';
import { SpacesProvider } from 'components/new/providers/SpacesProvider/SpacesProvider';

const cx = classNames.bind(styles);

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const { community, site, currentUser, trackEvent, featureFlags } = useCommunityContext();

  const { isMobile } = useWindowSize();
  useEffect(() => {
    setGlobalCSSVariables(community.primaryColor);
  }, [community]);

  return (
    <main className={cx('community-wrapper', 'is-spaces-in-communities-enabled')}>
      <EventPreviewProvider>
        <SpacesProvider communityId={community.id}>
          {!isMobile && (
            <Layout.Sidebar
              community={community}
              currentUser={currentUser}
              featureFlags={featureFlags}
              site={site}
              trackEvent={trackEvent}
            />
          )}
          <div className={cx('main-content')}>{children}</div>
        </SpacesProvider>
      </EventPreviewProvider>
    </main>
  );
};

export const getLayout = (page: ReactNode): ReactNode =>
  getSiteLayout(<MainLayout>{page}</MainLayout>);

export default MainLayout;
